import _typeof from "@babel/runtime/helpers/typeof";
import _lowerCase from 'lodash/lowerCase';
import _capitalize from 'lodash/capitalize';
import _replace from 'lodash/replace';
export var capitalizeFirstLetters = function capitalizeFirstLetters(str) {
  return str ? str.toLowerCase().split(' ').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ') : '';
};
export var capitalizeFirstLetterOnly = function capitalizeFirstLetterOnly(str) {
  return str ? str.split(' ').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ') : '';
};
export var capitalize = function capitalize(str) {
  return str.toUpperCase();
};
/**
 * string interpolation
 * @param {*} str
 * @param {*} obj
 */

export var stringInterpolate = function stringInterpolate() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return str.replace(/{([^{}]*)}/g, function (rawString, key) {
    return typeof rawString === 'string' && _typeof(obj) === 'object' ? obj[key] : rawString;
  });
};
/**
 * @name toCapitalize
 * @description
 * Capitalize any string
 * Any string of the form camelcase, hyphenated will be converted into
 * space separated capitalize string
 * e.g. : endAmount => End AMOUNT
 * @param string obj
 * @return string
 */

export var toCapitalize = function toCapitalize(str) {
  return _capitalize(_lowerCase(str));
};
export var toTitleCase = function toTitleCase(str) {
  return str ? _replace(str, /\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  }) : str;
};